import { Bell } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import { useUnreadCount } from '../../api/queries/notifications'
import { useAuth } from '../../hooks/useAuth'
import { getVerticalMeta, useVertical } from './useVertical'

export function NotificationBell() {
  const navigate = useNavigate()
  const { activeRole } = useAuth()
  const { activeVertical } = useVertical()
  // Demand-side roles see vertical-scoped counts; ops/admin/fulfiller see all.
  const scopedVertical =
    activeRole === 'consumer' || activeRole === 'creator'
      ? getVerticalMeta(activeVertical).backendId
      : undefined
  const { data } = useUnreadCount(scopedVertical)
  const count = data?.unread_count ?? 0

  return (
    <button
      onClick={() => navigate('/notifications')}
      className="relative rounded-2xl border border-stone-200 bg-white p-3 text-stone-600 shadow-sm transition hover:bg-stone-50"
      aria-label={count > 0 ? `${count} unread notifications` : 'Notifications'}
    >
      <Bell className="h-5 w-5" />
      {count > 0 && (
        <span className="absolute -right-1 -top-1 flex h-5 min-w-5 items-center justify-center rounded-full bg-red-600 px-1.5 text-[10px] font-bold text-white">
          {count > 99 ? '99+' : count}
        </span>
      )}
    </button>
  )
}
